var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"marker-action",attrs:{"tabindex":"0"}},[_c('list-action-form',{ref:"form",attrs:{"ids":_vm.ids,"labels":_vm.labels,"route":_vm.route,"method":_vm.method},on:{"submitted":_vm.submit}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }